"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var styled_components_1 = require("styled-components");

var styled_system_1 = require("styled-system");

var Column = styled_components_1.default.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var compact = _a.compact,
      breakpoints = _a.theme.breakpoints;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex: 1;\n    word-break: break-word;\n    align-items: center;\n    display: flex;\n    padding: ", "px;\n    font-size: 1rem;\n\n    @media (max-width: ", ") {\n      padding: ", "px;\n    }\n  "], ["\n    flex: 1;\n    word-break: break-word;\n    align-items: center;\n    display: flex;\n    padding: ", "px;\n    font-size: 1rem;\n\n    @media (max-width: ", ") {\n      padding: ", "px;\n    }\n  "])), compact ? '10' : '20', breakpoints.sm, compact ? '5' : '15');
});
var Heading = styled_components_1.default(Column).attrs({
  as: 'th'
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 1.2rem;\n"], ["\n  font-weight: bold;\n  font-size: 1.2rem;\n"])));
var Row = styled_components_1.default.tr(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (_a) {
  var isStriped = _a.isStriped,
      disableHover = _a.disableHover,
      disableClick = _a.disableClick,
      colors = _a.theme.colors,
      themeStyles = _a.themeStyles;
  return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));\n    cursor: pointer;\n    ", "\n\n    ", "\n\n\n    ", ";\n    ", "\n  "], ["\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));\n    cursor: pointer;\n    ", "\n\n    ", "\n\n\n    ", ";\n    ", "\n  "])), isStriped && "\n      &:nth-child(even) {\n        background-color: " + colors.baseOffset + ";\n      }\n    ", !isStriped && !disableHover && "\n        &:hover {\n          background-color: " + colors.baseOffset + ";\n        }\n    ", disableClick && 'cursor: default;', themeStyles);
}, styled_system_1.grid);
var Container = styled_components_1.default.table(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 100%;\n  ", "\n"], ["\n  width: 100%;\n  ", "\n"])), function (_a) {
  var themeStyles = _a.themeStyles;
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), themeStyles);
});
var Header = styled_components_1.default.thead(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      showMobileHeaders = _a.showMobileHeaders;
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      ", ";\n    }\n  "], ["\n    @media (max-width: ", ") {\n      ", ";\n    }\n  "])), theme.breakpoints.sm, !showMobileHeaders && 'display: none;');
});
exports.Table = {
  Column: Column,
  Row: Row,
  Container: Container,
  Header: Header,
  Heading: Heading
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;